import axios from '@/plugins/Axios'
import Mapper from './Mapper'

function Requests () {
  async function fetchUserCart () {
    try {
      const { data } = await axios.get('/cart')
      if (data.cart_items.length) {
        return data.cart_items.map(item => Mapper.cartProduct(item))
      } else {
        return []
      }
    } catch (error) {
      console.log(error)
    }
  }

  async function updateUserCartItem (item) {
    try {
      const formData = {
        quantity: item.quantity,
        inco_terms: item.inco_terms
      }
      const { data } = await axios.put(`/cart/${item.cartId}`, formData)
      return data.result
    } catch (error) {
      console.log(error)
    }
  }

  async function addItemToUserCart (item) {
    try {
      const formData = {
        product: item.id,
        quantity: item.quantity,
        inco_terms: item.inco_terms
      }
      const { data } = await axios.post(`/cart`, formData)
      return Mapper.cartProduct(data.cart_item[0])
    } catch (error) {
      console.log(error)
    }
  }

  async function removeItemFromUserCart (item) {
    try {
      const { data } = await axios.delete(`/cart/${item.cartId}`)
      return data.result
    } catch (error) {
      console.log(error)
    }
  }

  return {
    fetchUserCart,
    updateUserCartItem,
    addItemToUserCart,
    removeItemFromUserCart
  }
}

export default Requests()